import "./navbar.css";
// import data from "../../data/userPages.json"
import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { ReactComponent as GtRegLongLogo } from "../../assets/gobeyond-regcom-logo-new.svg";
import { ReactComponent as UserAvatar } from "../../assets/user.svg";
import { ReactComponent as ReportIcon } from "../../assets/report-icon.svg";
import { ReactComponent as LogIcon } from "../../assets/file-with-text-icon.svg";
import { ReactComponent as DownloadManual } from "../../assets/download-manual.svg";
import { ReactComponent as Building } from "../../assets/building.svg";
import { ReactComponent as FileIcon } from "../../assets/file-plus-02.svg";
import { Button, Tooltip, Select } from "antd";
import AccountPopover from "./AccountPopover";
import { Popover } from "@mui/material";
import { isEmpty } from "lodash";
import PlatformSwitcher from "./PlatformSwitcher";

const Navbar = ({ type }) => {
  const dispatchito = useDispatch();

  const isRunningOnVM2 = () => {
    return process.env.REACT_APP_FILE_HOST === "regcom-uat.grantthornton.gr";
  };
  const isRunningOnVM1 = () => {
    return process.env.REACT_APP_FILE_HOST === "regcom-qa.grantthornton.gr";
  };
  const user = useSelector(state => state.user);
  const config = useSelector(state => state.forms.appConfig);
  const organizations = useSelector(state => state.organizations.organizations);
  const organizationId = useSelector(
    state => state.organizations.organizationId
  );
  const { Option } = Select;
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(false);
  const [burgerOpen, setBurgerOpen] = useState(false);

  // Some sessions return roleAudit as an empty string when not set.
  // Normalize it to a boolean so refresh behaves the same as after login.
  const hasAuditRole = !!(user?.roleAudit && String(user.roleAudit).trim().length > 0);

  const customerName =
    organizations?.find(org => organizationId && org._id === organizationId)
      ?.customerName ?? "";

  const manualTitle = (role) => {
    let filename = '';
    switch (role) {
      case 'masterEditor':
        filename = 'Master Editor Manual v1.3.pdf';
        break;
      case 'corporateEditor':
        filename = 'Corporate Editor Manual v1.3.pdf';
        break;
      case 'groupComplianceAssessor':
        filename = 'Group Compliance Assessor Manual v1.3.pdf';
        break;
      case 'corporateComplianceAssessor':
        filename = 'Corporate Compliance Assessor Manual v1.3.pdf';
        break;
      case 'assignedUser':
        filename = 'Assigned user Manual v1.3.pdf';
        break;
      default:
        filename = 'Assigned user Manual v1.3.pdf';
    }
    return filename;
  }

  const manualHref = (role) => {
    let path = process.env.PUBLIC_URL + "/";
    switch (role) {
      case 'masterEditor':
        path += 'Master Editor Manual v1.3.pdf';
        break;
      case 'corporateEditor':
        path += 'Corporate Editor Manual v1.3.pdf';
        break;
      case 'groupComplianceAssessor':
        path += 'Group Compliance Assessor Manual v1.3.pdf';
        break;
      case 'corporateComplianceAssessor':
        path += 'Corporate Compliance Assessor Manual v1.3.pdf';
        break;
      case 'assignedUser':
        path += 'Assigned user Manual v1.3.pdf';
        break;
      default:
        path += 'Assigned user Manual v1.3.pdf';
      }
    return path;
  }

  
  const openAccountPopover = () => event => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const onOrgChange = value => {
    // console.debug("value", value);
    dispatchito({ type: "SET_SELECTED_ORGANIZATION_ID", payload: value });
  };

  const isLoginPage = location.pathname === "/login";

  const isChangePassword = location.pathname === "/change-password";

  return (
    <div className={`navbar${!user ? " login-page" : ""}`}>
      <div className="navContainer" id="navbar-container">
        <div className="gtLogo" id="nav-bar-gt-logo">
          {isChangePassword ? (
            <Link to="/login">
              <GtRegLongLogo style={{ width: "12.5rem" }} />
            </Link>
          ) : (
            <>
              <div className="brand-wrapper">
                {hasAuditRole && (
                  <button
                    className={`hamburger ${burgerOpen ? 'hamburger-open' : ''}`}
                    aria-label="Toggle menu"
                    onClick={() => setBurgerOpen((prev) => !prev)}
                  >
                    <span />
                    <span />
                    <span />
                  </button>
                )}

                <Link
                  to={user ? config?.pageList?.[user?.role]?.[0] : "/login"}
                  style={{
                    color: "inherit",
                    textDecoration: "none",
                    display: "flex",
                    paddingTop: "0.3rem"
                  }}
                >
                  <GtRegLongLogo style={{ width: "12.5rem" }} />
                  {/* {user?.role?.includes("admin") &&(
                <div>
                  <span id="version-info-text">v1.03</span>
                </div>
              )} */}
                </Link>

                {burgerOpen && hasAuditRole && <PlatformSwitcher />}
              </div>

              {user?.role?.includes("admin") && (
                <div>
                  <a
                    id="version-info-text"
                    href={process.env.PUBLIC_URL + "/version_info.txt"}
                    download={"info_regcom_v1.0.4.txt"}
                  >
                    v1.0.4
                  </a>
                </div>
              )}
            </>
          )}
        </div>
        {!isEmpty(user) && !isChangePassword && (
          <nav>
            <ul>
              {(user?.role?.includes("Editor") ||
                user?.role?.includes("assignedUser") ||
                user?.role?.includes("corporateCompliance")) &&
                customerName && (
                  <>
                    <li className="companyName" id="navbar-page-company-name">
                      <Building />
                      <span>{customerName}</span>
                    </li>
                    <li className="separator" id="navbar-page-separator-4"></li>
                  </>
                )}
              {user?.role?.includes("group") && (
                <>
                  {" "}
                  <Select
                    virtual={false}
                    // dropdownStyle={{ maxHeight: "15.625rem" }}
                    value={organizationId}
                    id="complianceCat"
                    placeholder="Select Organization"
                    size="large"
                    onChange={onOrgChange}
                    className="companyName"
                  >
                    {organizations &&
                      organizations?.map((item, index) => {
                        if (item) {
                          return (
                            <Option value={item._id} key={`org-${item._id}`}>
                              <Building className="building" />
                              {item?.customerName}
                            </Option>
                          );
                        }
                        return null;
                      })}
                  </Select>
                  <li className="separator" id="navbar-separator-2"></li>
                </>
              )}
              {config?.pageList?.[user?.role]?.includes("home-page") && (
                <li>
                  <NavLink to="/home-page" id="navbar-home-4">
                    Home
                  </NavLink>
                </li>
              )}
              {config?.pageList?.[user?.role]?.includes("signup") && (
                <li>
                  <NavLink to="/signup" id="navbar-signup">
                    Sign Up
                  </NavLink>
                </li>
              )}
              {config?.pageList?.[user?.role]?.includes("config-page") && (
                <li>
                  <NavLink to="/config-page" id="navbar-config">
                    Configuration
                  </NavLink>
                </li>
              )}
              {config?.pageList?.[user?.role]?.includes(
                "regulatory-universe"
              ) && (
                <li>
                  <NavLink
                    to="/regulatory-universe"
                    id="navbar-regulatory-universe-link-4"
                  >
                    Regulatory Universe
                  </NavLink>
                </li>
              )}
              {config?.pageList?.[user?.role]?.includes("organizations") && (
                <li>
                  <NavLink to="/organizations" id="navbar-organizations-link-6">
                    Organizations
                  </NavLink>
                </li>
              )}
              {config?.pageList?.[user?.role]?.includes("my-checklist") && (
                <li className="headerText" id="navbar-header-text-4">
                  <NavLink to="/my-checklist" id="navbar-my-checklist-link-4">
                    <span>My Checklist</span>
                  </NavLink>
                </li>
              )}
              {config?.pageList?.[user?.role]?.includes("my-tasks") && (
                <li>
                  <NavLink to="my-tasks" id="navbar-my-tasks-1">
                    My Tasks
                  </NavLink>
                </li>
              )}
              {config?.pageList?.[user?.role]?.includes(
                "internal-obligations"
              ) && (
                <li className="headerText" id="navbar-header-text">
                  <NavLink
                    to="/internal-obligations"
                    id="navbar-internal-obligations-1"
                  >
                    <span>Internal Obligations</span>
                  </NavLink>
                </li>
              )}

              {config?.pageList?.[user?.role]?.includes("reports") && (
                <li>
                  <NavLink
                    to="/reports"
                    // target={"_blank"}
                    className="navbar-icon"
                    id="navbar-page-icon-reports"
                  >
                    <Tooltip
                      placement="bottom"
                      title="Reports"
                      id="navbar-reports-3"
                    >
                      <Button shape="circle" icon={<ReportIcon />} />
                    </Tooltip>
                  </NavLink>
                </li>
              )}

              {config?.pageList?.[user?.role]?.includes("doc-repo") && (
                <li>
                  <NavLink
                    to="/doc-repo"
                    className="navbar-icon"
                    id="navbar-page-icon-doc-repo"
                  >
                    <Tooltip
                      placement="bottom"
                      title="Document Repository"
                      id="navbar-doc-repo-3"
                    >
                      <Button shape="circle" icon={<FileIcon />} />
                    </Tooltip>
                  </NavLink>
                </li>
              )}

              {config?.pageList?.[user?.role]?.includes("audit") && (
                <li>
                  <NavLink
                    to="/audit"
                    className="navbar-icon"
                    id="navbar-page-icon-audit"
                  >
                    <Tooltip
                      placement="bottom"
                      title="Audit"
                      id="navbar-audit-3"
                    >
                      <Button shape="circle" icon={<LogIcon />} />
                    </Tooltip>
                  </NavLink>
                </li>
              )}
              {user?.role !== "admin" && (
                <li>
                  <a
                    className="navbar-icon"
                    id="navbar-page-icon-2"
                    href={
                      manualHref(user.role)
                    }
                    download={
                      manualTitle(user.role)
                    }
                  >
                    <Tooltip
                      placement="bottom"
                      title="User Manual"
                      id="navbar-user-manual-1"
                    >
                      <Button shape="circle" icon={<DownloadManual />} />
                    </Tooltip>
                  </a>
                </li>
              )}
            </ul>
            <div
              className="header-icon"
              id="navbar-page-icon-1"
              onClick={e => openAccountPopover()(e)}
            >
              <Tooltip
                placement="bottom"
                title="User Profile"
                id="navbar-user-profile-2"
              >
                <UserAvatar />
              </Tooltip>
            </div>
            <Popover
              id={"simple-popover-user"}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center"
              }}
            >
              <AccountPopover
                user={user}
                setOpen={setOpen}
                setAnchorEl={setAnchorEl}
                customerName={customerName}
              />
            </Popover>
          </nav>
        )}
        {!isEmpty(user) &&
          isChangePassword && ( //show only profile icon
            <nav>
              <div
                className="header-icon"
                id="navbar-page-icon-1"
                onClick={e => openAccountPopover()(e)}
              >
                <Tooltip
                  placement="bottom"
                  title="User Profile"
                  id="navbar-user-profile-2"
                >
                  <UserAvatar />
                </Tooltip>
              </div>
              <Popover
                id={"simple-popover-user"}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
              >
                <AccountPopover
                  user={user}
                  setOpen={setOpen}
                  setAnchorEl={setAnchorEl}
                  customerName={customerName}
                />
              </Popover>
            </nav>
          )}
      </div>
    </div>
  );
};

export default Navbar;
